import "../../utils/tailwind.css";
import { useState } from "react";
import { PageProvider, useAddWorkProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form } from "formik";
import ReactQuill from "react-quill";
import DragDropImage from "../../components/imageDragAndDrop";
import Switch from "../../components/switch";
import slugify from "slugify";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = useAddWorkProvider();
  const [isSlugEdited, setIsSlugEdited] = useState(false);

  return (
    <Section className="h-[80vh] overflow-y-auto ">
      <Label label="Add Work Details" className="text-[18px] text-black" />
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3">
              <div className="flex items-center space-x-2">
                <Label
                  label="Is Published ?"
                  className="text-black mr-4 mt-3 text-[15px]"
                />
                <Switch
                  className="pt-1"
                  type="switch"
                  name="is_publish"
                  onChange={(val) => setFieldValue("works.is_publish", val)}
                  checked={values?.works?.is_publish}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="flex flex-col">
                <Label
                  label="Meta Title"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="works.meta_title" rootClassName="w-full" />
              </div>

              <div className="flex flex-col">
                <Label
                  label="Meta Keywords"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput
                  name="works.meta_keywords"
                  rootClassName="w-full"
                  className="h-[26rem]"
                />
              </div>
              <div className="flex flex-col ">
                <Label
                  label="Meta Description"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput
                  name="works.meta_description"
                  rootClassName="w-full"
                  className="h-[26rem]"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 mt-2 gap-3">
              <div className="flex flex-col">
                <Label
                  label="Heading"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput
                  name="works.title"
                  rootClassName="w-full"
                  value={values.works?.title || ""}
                  onChange={(e) => {
                    const newTitle = e.target.value;
                    setFieldValue("works.title", newTitle);
                    if (!isSlugEdited) {
                      setFieldValue(
                        "works.slug_url",
                        slugify(newTitle, { lower: true })
                      );
                    }
                  }}
                />
              </div>

              <div className="flex flex-col">
                <Label
                  label="Slug URL"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput
                  name="works.slug_url"
                  rootClassName="w-full"
                  value={values.works?.slug_url || ""}
                  onChange={(e) => {
                    setIsSlugEdited(true);
                    setFieldValue("works.slug_url", e.target.value);
                  }}
                />
              </div>

              <div className="flex flex-col">
                <Label
                  label="Heading Color"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="works.color" rootClassName="w-full" />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
              <div className="flex flex-col">
                <Label
                  label="Short Description (Sub Heading)"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="works.sub_heading" rootClassName="w-full" placeholder="e.g. A frictionless salary-advance app..." />
              </div>

              <div className="flex flex-col">
                <Label
                  label="Paragraph Info"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="works.paragraph_info" rootClassName="w-full" placeholder="e.g. Rebranding strategy, UI/UX design..." />
              </div>
            </div>

            {/* Challenge, Approach, Solution */}
            <div className="mt-4 border p-3 rounded-lg bg-gray-50">
              <Label label="Project Overview Details (Challenge, Approach & Solution)" className="text-[16px] font-semibold text-black mb-3" />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="flex flex-col">
                  <Label label="Challenge Heading" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.task_heading" rootClassName="w-full mb-2" />
                  <Label label="Challenge Description" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.task_desc" rootClassName="w-full" />
                </div>
                <div className="flex flex-col">
                  <Label label="Approach Heading" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.role_label" rootClassName="w-full mb-2" />
                  <Label label="Approach Description" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.role_desc" rootClassName="w-full" />
                </div>
                <div className="flex flex-col">
                  <Label label="Solution Heading" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.solution_heading" rootClassName="w-full mb-2" />
                  <Label label="Solution Description" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.solution_desc" rootClassName="w-full" />
                </div>
              </div>
            </div>

            {/* Stats Information */}
            <div className="mt-4 border p-3 rounded-lg bg-gray-50">
              <Label label="Stats Information (3 Highlight Metrics)" className="text-[16px] font-semibold text-black mb-3" />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {[0, 1, 2].map((idx) => (
                  <div key={idx} className="border p-2 rounded bg-white">
                    <Label label={`Stat ${idx + 1} Value`} className="mb-1 text-black text-[13px]" />
                    <FormikInput name={`works.stats.${idx}.value`} rootClassName="w-full mb-2" placeholder="e.g. 3.2x or 94%" />
                    <Label label={`Stat ${idx + 1} Label`} className="mb-1 text-black text-[13px]" />
                    <FormikInput name={`works.stats.${idx}.label`} rootClassName="w-full" placeholder="e.g. INCREASE IN DAILY ACTIVE USERS" />
                  </div>
                ))}
              </div>
            </div>

            {/* Before vs After */}
            <div className="mt-4 border p-3 rounded-lg bg-gray-50">
              <Label label="Before vs After Comparison" className="text-[16px] font-semibold text-black mb-3" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-2">
                <div className="flex flex-col">
                  <Label label="Section Badge" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.before_after.badge" rootClassName="w-full" placeholder="The Transformation" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex flex-col border p-3 rounded bg-white">
                  <Label label="BEFORE Title" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.before_after.before_title" rootClassName="w-full mb-2" />
                  <Label label="BEFORE Description (Use newlines for points)" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.before_after.before_desc" rootClassName="w-full" />
                </div>
                <div className="flex flex-col border p-3 rounded bg-white">
                  <Label label="AFTER Title" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.before_after.after_title" rootClassName="w-full mb-2" />
                  <Label label="AFTER Description (Use newlines for points)" className="mb-1 text-black text-[14px]" />
                  <FormikInput name="works.before_after.after_desc" rootClassName="w-full" />
                </div>
              </div>
            </div>

            {/* Outcome and Client Feedback */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4 border p-3 rounded-lg bg-gray-50">
              <div className="flex flex-col">
                <Label label="The Outcome Statement" className="mb-2 text-black text-[15px] font-semibold" />
                <FormikInput name="works.outcome_desc" rootClassName="w-full" placeholder="e.g. Twin Salary launched a product employees actually understood on day one..." />
              </div>
              <div className="flex flex-col">
                <Label label="Client Feedback Quote" className="mb-1 text-black text-[14px] font-semibold" />
                <FormikInput name="works.client_feedback.quote" rootClassName="w-full mb-2" placeholder="e.g. Strategy Soda took our messy MVP and turned it into..." />
                <Label label="Client Feedback Author" className="mb-1 text-black text-[14px] font-semibold" />
                <FormikInput name="works.client_feedback.author" rootClassName="w-full" placeholder="e.g. — Founder and CEO, Twin Salary" />
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3 mt-3">
              <div className="flex flex-col">
                <Label
                  label="Keywords (' , ' separated)"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="works.keywords" rootClassName="w-full" />
              </div>
              <div className="flex flex-col  ">
                <Label
                  label="Site Link"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="works.site_link" rootClassName="w-full" />
              </div>
              <div className="flex flex-col">
                <Label
                  label="Order Index"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput
                  name="works.order_index"
                  type="number"
                  rootClassName="w-full"
                />
              </div>
            </div>
            <div className="w-full mt-3">
              <Label
                label="Detailed Overview Description"
                className="mb-2 text-black text-[15px]"
              />
              <ReactQuill
                theme="snow"
                value={values.works.description}
                onChange={(e) => setFieldValue("works.description", e)}
              />
            </div>

            <div className="w-full mt-3 ">
              <Label
                label={
                  <>
                    Upload Images (
                    <b className="font-medium">
                      Please Upload Minimum 2 Images
                    </b>
                    )
                  </>
                }
                className="mb-2 text-black text-[15px]"
              />
              <DragDropImage
                setFieldValue={setFieldValue}
                fieldName="works.images"
                values={values}
                isDragAndDrop={true}
              />
            </div>

            <div className="w-full mt-3 ">
              <Label
                label={
                  <>
                    Upload Reels (
                    <b className="font-medium">Please Upload Minimum 4 Reels</b>
                    )
                  </>
                }
                className="mb-2 text-black text-[15px]"
              />
              <DragDropImage
                setFieldValue={setFieldValue}
                fieldName="works.reels"
                values={values}
                isDragAndDrop={true}
              />
            </div>

            <div className="w-full mt-3">
              <Label
                label={
                  <>
                    Upload Banner Images/Videos (
                    <b className="font-medium">
                      Please Upload Minimum 2 Images/Videos
                    </b>
                    )
                  </>
                }
                className="mb-2 text-black text-[15px]"
              />
              <DragDropImage
                setFieldValue={setFieldValue}
                fieldName="works.multiple_images"
                values={values}
                isDragAndDrop={true}
              />
            </div>

            <div className="w-full mt-3 mb-5 ">
              <Label
                label={
                  <>
                    Upload Booklets (
                    <b className="font-medium">
                      Please Upload Minimum 2 Booklets
                    </b>
                    )
                  </>
                }
                className="mb-2 text-black text-[15px]"
              />
              <DragDropImage
                setFieldValue={setFieldValue}
                fieldName="works.portfolio_images"
                values={values}
                isDragAndDrop={true}
              />
            </div>
            <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
